import configService from './app-config.service';

const getMOURisk = async (authToken, imoNumber) => {
    try {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${authToken}`);

        const options = {
            method: 'GET',
            headers: headers
        };

        imoNumber = imoNumber.replace('/', '');
        const response = await fetch(`${configService.appConfig.apiUrl}/MOU/Vessel/${imoNumber}`, options);

        if (!response.ok) {
            const message = `An error occurred: ${response.statusText}`;
            console.error(message);
            return;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (err) {
        return undefined;
    }
};

const MOUService = {
    getMOURisk
};

export default MOUService;
